module.exports = __webpack_public_path__ + "static/media/icon_pdf.3fa92281.svg";